import React from "react";
import {udnService} from "../jwt/_services";

export const udnProvider = {
    getOptions,
    getItem,
    getModulesUdn,
    getOptionsByCustomFilter,
};

async function getOptions( customFilter = null ){
    try {

        const listItems = await udnService.search(0, 1000, customFilter);
        listItems.data.sort((a, b) =>  a?.showOrder - b?.showOrder);
        return listItems.data.map( item => ({
            id: item?.id,
            value: item?.code + '-' + item?.name,
            label: <label>{ item?.code + ' - '  } <b>{ item?.name }</b> </label>
        }));
    } catch (error) {
       console.log(error.message)
    }
}


async function getItem(id){
    try {
        const item = await udnService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}

async function getModulesUdn(){
    try {
        const udnsList = await ( localStorage.getItem('udns') != '' ? JSON.parse(localStorage.getItem('udns')) : null);
        return udnsList.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getOptionsByCustomFilter(filters) {
    try {
        const listItems = await udnService.getOptions( filters );
        listItems.data.sort((a, b) => a.title.localeCompare(b.title));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getSchedules(filters) {
    try {
        const listItems = await udnService.getOptions( filters );
        listItems.data.sort((a, b) => a.title.localeCompare(b.title));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}